var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownoadkit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 15C4.5875 15 4.23425 14.853 3.94025 14.559C3.64625 14.265 3.4995 13.912 3.5 13.5V11.25H5V13.5H14V11.25H15.5V13.5C15.5 13.9125 15.353 14.2657 15.059 14.5597C14.765 14.8538 14.412 15.0005 14 15H5ZM9.5 12L5.75 8.25L6.8 7.1625L8.75 9.1125V3H10.25V9.1125L12.2 7.1625L13.25 8.25L9.5 12Z",
    fill: "#5A5A67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownoadkit);
export default __webpack_public_path__ + "static/media/downoadkit.9fb6e676484895592e8dc9966664a254.svg";
export { ForwardRef as ReactComponent };